/** Produz o próximo estado para uma transação PHP/MySQL, sem efeitos colaterais. */
export function revisePlan(existing: Record<string, any>, changes: Record<string, any>, expectedRevision: number, nutritionistId: string, archivedAt: unknown) {
  const revision = Number(existing.revision ?? 0);
  if (revision !== expectedRevision) {
    throw new Error('Este plano foi alterado em outra sessão. Feche o editor e abra a versão atual antes de salvar.');
  }
  if (existing.nutritionistId && existing.nutritionistId !== nutritionistId) {
    throw new Error('Plano de outro nutricionista');
  }
  const { versions = {}, ...snapshot } = existing;
  return {
    ...snapshot, ...changes, revision: revision + 1,
    versions: {
      ...versions,
      [`v${revision}`]: { ...snapshot, revision, archivedAt, archivedBy: nutritionistId },
    },
  };
}
